// extracted by mini-css-extract-plugin
module.exports = {"container":"RejectedPayment_container_1rXP8","image":"RejectedPayment_image_cl6mE","information":"RejectedPayment_information_oy_Vp","copy":"RejectedPayment_copy_1wpVL"};